<template>
    <div>
        <!--导航栏-->
        <van-nav-bar
                title="个人设置"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏-->


        <div style="margin-top: 1.5rem;">

            <div>
                <van-cell-group>
                    <van-cell title="账户名" :value="salesmanInfo.name"/>
                    <van-cell title="唯一编号" :value="salesmanInfo.salesman_num"/>
                    <van-cell title="手机号" :value="salesmanInfo.tel"/>
                    <van-cell title="备注信息" :value="salesmanInfo.info"/>
                </van-cell-group>
            </div>
            <div style="padding: 0.3rem">
                <van-button type="primary" block @click="logout">退出登录</van-button>

            </div>

        </div>
    </div>
</template>

<script>
    import VueCookie from 'vue-cookies'
    import {Dialog} from 'vant';

    //个人设置
    export default {
        name: "SalesmanSetting",
        data() {
            return {
                salesmanInfo: VueCookie.get("salesmanInfo")
            }
        },
        methods: {
            //导航栏左侧返回
            onClickLeft() {
                this.$router.push("/");
            },
            //退出登录
            logout() {

                Dialog.confirm({
                    title: '温馨提示',
                    message: '确认要退出当前业务员账号吗？',
                })
                    .then(() => {
                        VueCookie.remove("salesmanInfo");
                        this.$router.push("/SalesmanLogin");
                    })
                    .catch(() => {
                        // on cancel
                    });


            }
        }
    }
</script>

<style scoped>

</style>